import React from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

const AgentProfile = () => {
  const { currentUser } = useAuth();

  // Get display name (fallback to email prefix if not set)
  const displayName =
    currentUser?.displayName || currentUser?.email?.split('@')[0] || 'User';

  return (
    <Container className='mt-4'>
      <Row className="justify-content-center">
        <Col md={6}>
          <Card>
            <Card.Header>
              <h3>Profile</h3>
            </Card.Header>
            <Card.Body>
              <p><strong>Name:</strong> {displayName}</p>
              {/* <p><strong>User ID:</strong> {currentUser.uid}</p> */}
              <p><strong>Last Login:</strong> {new Date(currentUser.metadata.lastSignInTime).toLocaleString()}</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AgentProfile;
